import type { DefaultConfigOptions } from '@formkit/vue'
import { createFloatingLabelsPlugin } from '@formkit/addons'
import { en, pl, ru } from '@formkit/i18n'
import { validateNip } from './utils/validateNip'
import { createAutoHeightTextareaPlugin } from '~/formkit/plugins/autoHeight'
import { setFocus } from '~/formkit/plugins/setFocus'

const config: DefaultConfigOptions = {
    plugins: [
        createFloatingLabelsPlugin({
            useAsDefault: true,
        }),
        createAutoHeightTextareaPlugin(),
        setFocus(),
    ],
    rules: {
        nip: validateNip,
    },
    locales: { pl, en, ru },
    locale: 'pl',
}

export default config
